/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum FocusArea {
  AlternativeDisputeResolution = "AlternativeDisputeResolution",
  AdvertisingTechnology = "AdvertisingTechnology",
  AntitrustAndCompetition = "AntitrustAndCompetition",
  ArtificialIntelligence = "ArtificialIntelligence",
  AssetFinanceAndLeasing = "AssetFinanceAndLeasing",
  BankruptcyAndReorganization = "BankruptcyAndReorganization",
  BriberyAndCorruption = "BriberyAndCorruption",
  CloudSaaSSoftwareLicensing = "CloudSaaSSoftwareLicensing",
  CommercialBanking = "CommercialBanking",
  CommercialContracts = "CommercialContracts",
  CommercialRealEstateAndLeasing = "CommercialRealEstateAndLeasing",
  ConsumerBankingAndLending = "ConsumerBankingAndLending",
  ConsumerProtectionRegulation = "ConsumerProtectionRegulation",
  Copyrights = "Copyrights",
  CorporateSecretaryAndServices = "CorporateSecretaryAndServices",
  CorporateTrustsLendingAndBorrowing = "CorporateTrustsLendingAndBorrowing",
  Cybersecurity = "Cybersecurity",
  DataPrivacy = "DataPrivacy",
  DebtCapitalMarkets = "DebtCapitalMarkets",
  Derivatives = "Derivatives",
  EmployeeInvestigations = "EmployeeInvestigations",
  EnergyRegulationAndCompliance = "EnergyRegulationAndCompliance",
  EnvironmentalSocialAndGovernanceCompliance = "EnvironmentalSocialAndGovernanceCompliance",
  EquityCapitalMarkets = "EquityCapitalMarkets",
  ERISACompensationPensionsAndBenefits = "ERISACompensationPensionsAndBenefits",
  FinancialServicesComplianceAndRegulation = "FinancialServicesComplianceAndRegulation",
  FinTechAndPayments = "FinTechAndPayments",
  GeneralCounselServices = "GeneralCounselServices",
  GeneralEmployment = "GeneralEmployment",
  GovernmentContracts = "GovernmentContracts",
  HealthcareRegulatoryAndCompliance = "HealthcareRegulatoryAndCompliance",
  Insurance = "Insurance",
  InvestmentAndWealthManagement = "InvestmentAndWealthManagement",
  InvestmentComplianceAndMarketAccess = "InvestmentComplianceAndMarketAccess",
  IntellectualPropertyLitigation = "IntellectualPropertyLitigation",
  LaborRelations = "LaborRelations",
  ConstructionPlanningAndDevelopment = "ConstructionPlanningAndDevelopment",
  LegalOperations = "LegalOperations",
  LifeSciencesCompliance = "LifeSciencesCompliance",
  LifeSciencesRegulatory = "LifeSciencesRegulatory",
  LifeSciencesSupplyChain = "LifeSciencesSupplyChain",
  Litigation = "Litigation",
  MAndADivestitures = "MAndADivestitures",
  LifeSciencesMarketAccessAndReimbursement = "LifeSciencesMarketAccessAndReimbursement",
  MarketingAndAdvertising = "MarketingAndAdvertising",
  EnergyNuclear = "EnergyNuclear",
  EnergyOilAndGas = "EnergyOilAndGas",
  Patents = "Patents",
  ProcurementAndOutsourcing = "ProcurementAndOutsourcing",
  ProductCounsel = "ProductCounsel",
  ClinicalTrials = "ClinicalTrials",
  RealEstateFinance = "RealEstateFinance",
  EnergyRenewable = "EnergyRenewable",
  SecuritiesAndPrimeBrokerage = "SecuritiesAndPrimeBrokerage",
  StructuredAndProjectFinance = "StructuredAndProjectFinance",
  SupplyChainTransportation = "SupplyChainTransportation",
  Tax = "Tax",
  TradeComplianceSanctionsAndExportControls = "TradeComplianceSanctionsAndExportControls",
  Trademarks = "Trademarks",
  EnergyUtilities = "EnergyUtilities",
  IPLicensing = "IPLicensing",
  InvestigationsAndEnforcement = "InvestigationsAndEnforcement",
}

export const FocusAreaDisplay: Record<FocusArea, string> = {
  [FocusArea.AlternativeDisputeResolution]: "ADR & Pre-Litigation",
  [FocusArea.AdvertisingTechnology]: "Advertising Technology",
  [FocusArea.AntitrustAndCompetition]: "Antitrust & Competition",
  [FocusArea.ArtificialIntelligence]: "Artificial Intelligence",
  [FocusArea.AssetFinanceAndLeasing]: "Asset-Based Financing & Leasing",
  [FocusArea.BankruptcyAndReorganization]: "Bankruptcy & Reorganization",
  [FocusArea.BriberyAndCorruption]: "Bribery & Corruption",
  [FocusArea.CloudSaaSSoftwareLicensing]: "Cloud, SaaS & Software Licensing",
  [FocusArea.CommercialBanking]: "Commercial Banking",
  [FocusArea.CommercialContracts]: "Commercial Contracts",
  [FocusArea.CommercialRealEstateAndLeasing]: "Commercial Real Estate & Leasing",
  [FocusArea.ConsumerBankingAndLending]: "Consumer Banking",
  [FocusArea.ConsumerProtectionRegulation]: "Consumer Protection Regulation",
  [FocusArea.Copyrights]: "Copyright Law",
  [FocusArea.CorporateSecretaryAndServices]: "Corporate Governance & Secretary Services",
  [FocusArea.CorporateTrustsLendingAndBorrowing]: "Corporate Trusts, Lending & Borrowing",
  [FocusArea.Cybersecurity]: "Cybersecurity Law",
  [FocusArea.DataPrivacy]: "Data Privacy",
  [FocusArea.DebtCapitalMarkets]: "Debt Capital Markets",
  [FocusArea.Derivatives]: "Derivatives Law",
  [FocusArea.EmployeeInvestigations]: "Employee Investigations",
  [FocusArea.EnergyRegulationAndCompliance]: "Energy Regulation & Compliance",
  [FocusArea.EnvironmentalSocialAndGovernanceCompliance]: "Environmental, Social & Governance Compliance (ESG)",
  [FocusArea.EquityCapitalMarkets]: "Equity Capital Markets",
  [FocusArea.ERISACompensationPensionsAndBenefits]: "ERISA, Compensation, Pensions & Benefits",
  [FocusArea.FinancialServicesComplianceAndRegulation]: "Financial Services Compliance & Regulation",
  [FocusArea.FinTechAndPayments]: "FinTech & Payments",
  [FocusArea.GeneralCounselServices]: "General Counsel Services",
  [FocusArea.GeneralEmployment]: "General Employment",
  [FocusArea.GovernmentContracts]: "Government Contracts",
  [FocusArea.HealthcareRegulatoryAndCompliance]: "Healthcare Regulatory & Compliance",
  [FocusArea.Insurance]: "Insurance Law",
  [FocusArea.InvestmentAndWealthManagement]: "Investment & Wealth Management",
  [FocusArea.InvestmentComplianceAndMarketAccess]: "Investment Compliance & Market Access",
  [FocusArea.IntellectualPropertyLitigation]: "IP Litigation",
  [FocusArea.LaborRelations]: "Labor Relations",
  [FocusArea.ConstructionPlanningAndDevelopment]: "Land, Construction, Planning & Development",
  [FocusArea.LegalOperations]: "Legal Operations",
  [FocusArea.LifeSciencesCompliance]: "Life Sciences Compliance",
  [FocusArea.LifeSciencesRegulatory]: "Life Sciences Regulatory",
  [FocusArea.LifeSciencesSupplyChain]: "Life Sciences Supply Chain & Manufacturing",
  [FocusArea.Litigation]: "Litigator",
  [FocusArea.MAndADivestitures]: "M&A & Divestitures",
  [FocusArea.LifeSciencesMarketAccessAndReimbursement]: "Market Access & Reimbursement",
  [FocusArea.MarketingAndAdvertising]: "Marketing & Advertising",
  [FocusArea.EnergyNuclear]: "Nuclear Energy",
  [FocusArea.EnergyOilAndGas]: "Oil & Gas",
  [FocusArea.Patents]: "Patents & Trade Secrets",
  [FocusArea.ProcurementAndOutsourcing]: "Procurement & Outsourcing",
  [FocusArea.ProductCounsel]: "Product Counsel",
  [FocusArea.ClinicalTrials]: "R&D & Clinical Trials",
  [FocusArea.RealEstateFinance]: "Real Estate Finance",
  [FocusArea.EnergyRenewable]: "Renewable Energy",
  [FocusArea.SecuritiesAndPrimeBrokerage]: "Securities & Prime Brokerage",
  [FocusArea.StructuredAndProjectFinance]: "Structured & Project Finance",
  [FocusArea.SupplyChainTransportation]: "Supply Chain & Transportation",
  [FocusArea.Tax]: "Tax Law",
  [FocusArea.TradeComplianceSanctionsAndExportControls]: "Trade Compliance, Sanctions & Export Controls",
  [FocusArea.Trademarks]: "Trademark Law",
  [FocusArea.EnergyUtilities]: "Utilities & Power",
  [FocusArea.IPLicensing]: "IP Licensing",
  [FocusArea.InvestigationsAndEnforcement]: "Investigations & Enforcement",
};
